import * as Types from '../actions';

export interface NotificationReducer {
  message?: string;
}

const initialState: NotificationReducer = {
  message: undefined,
};

export default (
  state = initialState,
  action: Types.NotificationAction
): NotificationReducer => {
  switch (action.type) {
    case Types.NOTIFICATION_SHOW:
      return { ...state, message: action.payload.message };
    case Types.NOTIFICATION_HIDE:
      return { ...state, message: undefined };
    default:
      return state;
  }
};
